import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { ProfessionalRfpProposalListLink } from '@/components/modules/pages/mypage/professional/List/ProfessionalRfpProposalList/ActionLink';
export const ProfessionalRfpProposalListOfferLink = (props) => {
    const { disabled, href } = props;
    return (_jsx(ProfessionalRfpProposalListLink, { badgeNumber: 0, color: 'orange', disabled: disabled, href: href, text: '提案する' }));
};
